<ng-container *ngIf="!rule.condition">
    <li id="builder-widgets_rule_0" class="rule-container">
        <div class="rule-header">
            <div class="btn-group pull-right rule-actions">
                <button type="button" class="delete-btn app-button btn btn-transparent"
                    title="{{locale.LABEL_DELETE_CRITERIA}}" (click)="deleteRule()">
                    <i class="wm-icon12 wms wms-delete"></i>
                </button>
            </div>
        </div>
        <div class="rule-filter-container">
            <div class="wms-typeahead-live-filter">
                <wms-typeahead name="wms-binding-column" (onSelect)="onFilterFieldSelect($event)" [editable]="true"
                    [model]="rule.target" [options]="filterCriteriaService.data.fields"></wms-typeahead>
            </div>
        </div>
        <div class="rule-operator-container">
            <!--TODO : ng-init="rule.matchMode" -->
            <select class="form-control app-select" [(ngModel)]="rule.matchMode"
                (change)="matchModeOnChange()">
                <option *ngFor="let matchMode of getMatchModes()" [value]="matchMode">
                    {{getMatchModeKey(matchMode)}}</option>
            </select>
        </div>
        <div class="rule-value-container" *ngIf="!isEmptyRule(rule.matchMode)">
            <span [ngSwitch]="rule.type">
                <span class="property-value" *ngSwitchCase="'date'">
                    <span
                        *ngIf="(!rule.value || (rule.value && rule.value.toString().indexOf('bind:') !== 0)) && ['in','notin'].indexOf(rule.matchMode) === -1">
                        <!-- TODO: datepattern="{{::getDisplayDateTimeFormat(\date\)}}"  -->
                        <input type="date" class="form-control app-textbox" [(ngModel)]="rule.value"
                            (change)="filterCriteriaService.markVariableUpdated()" />
                    </span>
                    <input class="form-control app-text app-widget-wrapper" type="text" wmsExpressionError [expression]="rule.value"
                        *ngIf="rule.value && rule.value.toString().indexOf('bind:') === 0 || ['in','notin'].indexOf(rule.matchMode) !== -1"
                        (change)="filterCriteriaService.markVariableUpdated()" [(ngModel)]="rule.value" [title]="rule.value"
                        placeholder="yyyy-MM-dd" readonly>
                    <button class="wm-icon12 clear wms wms-clear"
                        *ngIf="rule.value && rule.value.toString().indexOf('bind:') === 0"
                        (click)="clearBinding()"></button>
                </span>
                <span class="property-value" *ngSwitchCase="'datetime'">
                    <span
                        *ngIf="(!rule.value || (rule.value && rule.value.toString().indexOf('bind:') !== 0)) && ['in','notin'].indexOf(rule.matchMode) === -1">
                        <!--TODO:  <wm-datetime datepattern="{{::getDisplayDateTimeFormat(\datetime\)}}" hourstep="1"
                            minutestep="1" type="uib-picker" on-change="filterCriteriaService.markVariableUpdated()"
                            scopedatavalue="rule.value" outputformat="yyyy-MM-dd hh:mm:ss a"></wm-datetime> -->
                        <input type="datetime-local" 
                            [(ngModel)]="rule.value"
                            (change)="filterCriteriaService.markVariableUpdated()">
                    </span>
                    <input class="form-control app-text app-widget-wrapper" type="text" wmsExpressionError [expression]="rule.value"
                        *ngIf="rule.value && rule.value.toString().indexOf('bind:') === 0 || ['in','notin'].indexOf(rule.matchMode) !== -1"
                        (change)="filterCriteriaService.markVariableUpdated()" [(ngModel)]="rule.value" [title]="rule.value"
                        placeholder="yyyy-MM-dd hh:mm:ss a" readonly>
                    <button class="wm-icon12 clear wms wms-clear"
                        *ngIf="rule.value && rule.value.toString().indexOf('bind:') === 0"
                        (click)="clearBinding()"></button>
                </span>
                <span
                    *ngSwitchCase="rule.type === 'number' || rule.type === 'integer' || rule.type === 'big_integer' || rule.type === 'short' ||
                    rule.type === 'float' || rule.type === 'big_decimal' || rule.type === 'long' || rule.type === 'double' || rule.type === 'byte' ? rule.type : ''"
                    class="property-value">
                    <!-- TODO: ng-init="rule.value" -->
                    <input class="form-control app-text app-widget-wrapper" type="number"
                        *ngIf="(!rule.value || (rule.value && rule.value.toString().indexOf('bind:') !== 0)) && ['in','notin'].indexOf(rule.matchMode) === -1"
                        (change)="filterCriteriaService.markVariableUpdated()" [(ngModel)]="rule.value" [title]="rule.value">
                    <input class="form-control app-text app-widget-wrapper" type="text" wmsExpressionError [expression]="rule.value"
                        *ngIf="rule.value && rule.value.toString().indexOf('bind:') === 0 || ['in','notin'].indexOf(rule.matchMode) !== -1"
                        (change)="filterCriteriaService.markVariableUpdated()" [(ngModel)]="rule.value" [title]="rule.value"
                        readonly>
                    <button class="wm-icon12 clear wms wms-clear"
                        *ngIf="rule.value && rule.value.toString().indexOf('bind:') === 0"
                        (click)="clearBinding()"></button>
                </span>
                <span *ngSwitchCase="rule.type === 'string' || rule.type === 'text' || rule.type === 'time' || rule.type === 'timestamp' ||
                    rule.type === 'character' ? rule.type : ''" class="property-value">
                    <!-- TODO: ng-init="rule.value" -->
                    <input class="form-control app-text app-widget-wrapper" type="text"
                        (change)="filterCriteriaService.markVariableUpdated()" [(ngModel)]="rule.value" [title]="rule.value"
                        *ngIf="!rule.value || (rule.value && rule.value.toString().indexOf('bind:') !== 0)">
                    <input class="form-control app-text app-widget-wrapper" type="text" wmsExpressionError [expression]="rule.value"
                        (change)="filterCriteriaService.markVariableUpdated()" [(ngModel)]="rule.value" [title]="rule.value"
                        *ngIf="rule.value && rule.value.toString().indexOf('bind:') === 0" readonly>
                    <button class="wm-icon12 clear wms wms-clear"
                        *ngIf="(rule.value && rule.value.toString().indexOf('bind:') === 0)"
                        (click)="clearBinding()"></button>
                </span>
                <!-- for now just using the select, completely ignoring the checkbox -->
                <span *ngSwitchCase="'boolean'" class="property-value">
                    <!-- TODO: ng-init="rule.value = (rule.value !== \\) ? rule.value : true" -->
                    <select class="form-control app-select"
                        *ngIf="!rule.value || (rule.value && rule.value.toString().indexOf('bind:') !== 0)"
                        [(ngModel)]="rule.value" (change)="filterCriteriaService.markVariableUpdated()">
                        <option *ngFor="let option of booleanFieldOptions | keyvalue" [value]="option.key">
                            {{option.value}}</option>
                    </select>
                    <input class="form-control app-text app-widget-wrapper" type="text" wmsExpressionError [expression]="rule.value"
                        *ngIf="rule.value && rule.value.toString().indexOf('bind:') === 0"
                        (change)="filterCriteriaService.markVariableUpdated()" [(ngModel)]="rule.value" [title]="rule.value"
                        readonly>
                    <button class="wm-icon12 clear wms wms-clear"
                        *ngIf="rule.value && rule.value.toString().indexOf('bind:') === 0"
                        (click)="clearBinding()"></button>
                </span>
                <span *ngSwitchDefault class="property-value">
                    <!-- TODO:  ng-init="rule.value" -->
                    <input class="form-control app-text app-widget-wrapper" type="text"
                        (change)="filterCriteriaService.markVariableUpdated()" [(ngModel)]="rule.value" [title]="rule.value"
                        *ngIf="!rule.value || (rule.value && rule.value.toString().indexOf('bind:') !== 0)">
                    <input class="form-control app-text app-widget-wrapper" type="text" wmsExpressionError [expression]="rule.value"
                        (change)="filterCriteriaService.markVariableUpdated()" [(ngModel)]="rule.value" [title]="rule.value"
                        *ngIf="rule.value && rule.value.toString().indexOf('bind:') === 0" readonly>
                </span>
                <span class="rule-list-actions" *ngIf="filterCriteriaService.data.fields.indexOf(rule.target) !== -1">
                    <button (click)="openBindDialog()" class="wms wms-link"
                        title="{{locale.LABEL_BIND_VARIABLE}}" *ngIf="!showInput() && showBinding()"
                        ng-disabled="::disableBinding"></button>
                    <i *ngIf="showBinding()" class="wms wms-help" container="body"
                        tooltip="{{locale['MESSAGE_HELP_VARIABLE_ATTR_BIND']}}" placement="right"></i>
                </span>
            </span>
            <span class="rule-type-between col-md-12" *ngIf="rule.matchMode === 'between'">
                <span [ngSwitch]="rule.type">
                    <span *ngSwitchCase="'date'" class="property-value">
                        <span *ngIf="rule.secondvalue?.toString()?.indexOf('bind:') !== 0">
                            <!-- TODO: datepattern="{{::getDisplayDateTimeFormat(\date\)}}" -->
                            <input type="date" class="form-control app-textbox"
                                [(ngModel)]="rule.secondvalue" (change)="filterCriteriaService.markVariableUpdated()" />
                        </span>
                        <input class="form-control app-text app-widget-wrapper" type="text" wmsExpressionError [expression]="rule.secondvalue"
                            *ngIf="rule.secondvalue?.toString()?.indexOf('bind:') === 0 "
                            (change)="filterCriteriaService.markVariableUpdated()" [(ngModel)]="rule.secondvalue"
                            [title]="rule.secondvalue" readonly>
                        <button class="wm-icon12 clear wms wms-clear"
                            *ngIf="rule.secondvalue?.toString()?.indexOf('bind:') === 0"
                            (click)="clearBinding(1)"></button>
                    </span>
                    <span *ngSwitchCase="'datetime'" class="property-value">
                        <span *ngIf="rule.secondvalue?.toString()?.indexOf('bind:') !== 0">
                            <!-- TODO: <wm-datetime datepattern="{{::getDisplayDateTimeFormat(\datetime\)}}"
                                hourstep="1" minutestep="1" type="uib-picker"
                                on-change="filterCriteriaService.markVariableUpdated()" scopedatavalue="rule.secondvalue"
                                outputformat="yyyy-MM-dd hh:mm:ss a"></wm-datetime> -->
                            <input type="datetime-local" 
                            [(ngModel)]="rule.secondvalue"
                            (change)="filterCriteriaService.markVariableUpdated()">
                        </span>
                        <input wmsExpressionError [expression]="rule.secondvalue"
                            class="form-control app-text app-widget-wrapper" type="text"
                            *ngIf="rule.secondvalue?.toString()?.indexOf('bind:') === 0 "
                            (change)="filterCriteriaService.markVariableUpdated()" [(ngModel)]="rule.secondvalue"
                            title="{{rule.secondvalue}}" readonly>
                        <button class="wm-icon12 clear wms wms-clear"
                            *ngIf="rule.secondvalue?.toString()?.indexOf('bind:') === 0"
                            (click)="clearBinding(1)"></button>
                    </span>
                    <span
                        *ngSwitchCase="rule.type === 'number' || rule.type === 'integer' || rule.type === 'big_integer' || rule.type === 'short' ||
                        rule.type === 'float' || rule.type === 'big_decimal' || rule.type === 'long' || rule.type === 'double' || rule.type === 'byte' ? rule.type : ''"
                        class="property-value">
                        <!-- TODO: ng-init="rule.secondvalue" -->
                        <input class="form-control app-text app-widget-wrapper" type="number"
                            *ngIf="rule.secondvalue?.toString()?.indexOf('bind:') !== 0 && ['in','notin'].indexOf(rule.matchMode) === -1"
                            (change)="filterCriteriaService.markVariableUpdated()" [(ngModel)]="rule.secondvalue"
                            [title]="rule.secondvalue">
                        <input class="form-control app-text app-widget-wrapper" type="text" wmsExpressionError [expression]="rule.secondvalue"
                            *ngIf="rule.secondvalue?.toString()?.indexOf('bind:') === 0 || ['in','notin'].indexOf(rule.matchMode) !== -1"
                            (change)="filterCriteriaService.markVariableUpdated()" [(ngModel)]="rule.secondvalue"
                            [title]="rule.secondvalue" readonly>
                        <button class="wm-icon12 clear wms wms-clear"
                            *ngIf="rule.secondvalue?.toString()?.indexOf('bind:') === 0"
                            (click)="clearBinding(1)"></button>
                    </span>
                    <span *ngSwitchCase="rule.type === 'string' || rule.type === 'text' || rule.type === 'time' || rule.type === 'timestamp' ||
                        rule.type === 'character' ? rule.type : ''" class="property-value">
                        <!-- TODO:  ng-init="rule.secondvalue"  -->
                        <input class="form-control app-text app-widget-wrapper" type="text"
                            (change)="filterCriteriaService.markVariableUpdated()" [(ngModel)]="rule.secondvalue"
                            [title]="rule.secondvalue" *ngIf="rule.secondvalue?.toString()?.indexOf('bind:') !== 0">
                        <input class="form-control app-text app-widget-wrapper" type="text" wmsExpressionError [expression]="rule.secondvalue"
                            (change)="filterCriteriaService.markVariableUpdated()" [(ngModel)]="rule.secondvalue"
                            [title]="rule.secondvalue" *ngIf="rule.secondvalue?.toString()?.indexOf('bind:') === 0"
                            readonly>
                        <button class="wm-icon12 clear wms wms-clear"
                            *ngIf="rule.secondvalue?.toString()?.indexOf('bind:') === 0"
                            (click)="clearBinding(1)"></button>
                    </span>
                    <span *ngSwitchCase="'boolean'" class="property-value">
                        <!-- TODO: ng-init=" rule.secondvalue = (rule.secondvalue !== \\) ? rule.secondvalue : true" -->
                        <select class="form-control app-select"
                            *ngIf="rule.secondvalue?.toString()?.indexOf('bind:') !== 0" [(ngModel)]="rule.secondvalue"
                            (change)="filterCriteriaService.markVariableUpdated()">
                            <option *ngFor="let option of booleanFieldOptions | keyvalue"
                                [value]="option.key">{{option.value}}</option>
                        </select>
                        <input class="form-control app-text app-widget-wrapper" type="text" wmsExpressionError [expression]="rule.secondvalue"
                            *ngIf="rule.secondvalue?.toString()?.indexOf('bind:') === 0" (change)="filterCriteriaService.markVariableUpdated()"
                            [(ngModel)]="rule.secondvalue" [title]="rule.secondvalue" readonly>
                        <button class="wm-icon12 clear wms wms-clear"
                            *ngIf="rule.secondvalue?.toString()?.indexOf('bind:') === 0"
                            (click)="clearBinding(1)"></button>
                    </span>
                    <span *ngSwitchDefault class="property-value">
                        <!-- TODO:  ng-init="rule.secondvalue" -->
                        <input class="form-control app-text app-widget-wrapper" type="text"
                            (change)="filterCriteriaService.markVariableUpdated()" [(ngModel)]="rule.secondvalue"
                            [title]="rule.secondvalue" *ngIf="rule.secondvalue?.toString()?.indexOf('bind:') !== 0">
                        <input class="form-control app-text app-widget-wrapper" type="text" wmsExpressionError [expression]="rule.secondvalue"
                            (change)="filterCriteriaService.markVariableUpdated()" [(ngModel)]="rule.secondvalue"
                            [title]="rule.secondvalue" *ngIf="rule.secondvalue?.toString()?.indexOf('bind:') === 0"
                            readonly>
                    </span>
                </span>

                <span class="rule-list-actions" *ngIf="filterCriteriaService.data.fields.indexOf(rule.target) !== -1">
                    <!-- TODO: [disabled]="disableBinding" -->
                    <button (click)="openBindDialog(1)" class="wms wms-link"
                        [title]="locale.LABEL_BIND_VARIABLE"
                        *ngIf="rule.matchMode === 'between' && showBinding()"></button>
                    <i *ngIf="rule.matchMode === 'between' && showBinding()" class="wms wms-help"
                        container="body" tooltip="{{locale['MESSAGE_HELP_VARIABLE_ATTR_BIND']}}"
                        placement="right"></i>

                </span>
            </span>
        </div>
    </li>
</ng-container>